import { useState } from "react"
import { Button } from "reactstrap"
import ImporterGroupStocks from "./stocks/ImporterGroupStocks"
import ImporterStocks from "./stocks/ImporterStocks"
import TagImporterByFullChassis from "../components/TagImporterByFullChassis"
import CarStockList from "./stocks/components/CarStockList/CarStockList"
import CarStockWrapper from "./stocks/components/CarStockList/CarStockWrapper"
import { useListParams } from "hooks/useListParams"

const ImporterStockContainer = ({ importerId, importer }) => {
  const [isGrouped, setIsGrouped] = useState(false)
  const { params } = useListParams()
  return (
    <div>
      {/* View Toggle */}
      <div className="d-flex align-items-center mb-3">
        <div
          className="d-inline-flex align-items-center p-1 rounded"
          style={{
            background: "#f5f6f8",
            border: "1px solid #e9ecef",
          }}
        >
          {/* Normal View */}
          <Button
            size="sm"
            color={isGrouped ? "light" : "primary"}
            className="d-flex align-items-center gap-1 border-0"
            onClick={() => setIsGrouped(false)}
            style={{
              boxShadow: "none",
            }}
          >
            <i className="bx bx-list-ul font-size-16" />
            <span className="d-none d-sm-inline">List</span>
          </Button>

          {/* Group View */}
          <Button
            size="sm"
            color={isGrouped ? "primary" : "light"}
            className="d-flex align-items-center gap-1 border-0"
            onClick={() => setIsGrouped(true)}
            style={{
              boxShadow: "none",
            }}
          >
            <i className="bx bx-layer font-size-16" />
            <span className="d-none d-sm-inline">Group</span>
          </Button>
          {/* Tag Importer Button */}
          <TagImporterByFullChassis
            importerId={importerId}
            importer={importer}
          />
          {/* Download button */}
          <CarStockWrapper
            {...params}
            importer={importerId}
            btn={{ color: "success", size: "sm" }}
            allowedKeys={["page", "per_page", "grouped", "group_sort"]}
          />
        </div>
      </div>

      {/* Conditional Rendering */}
      {isGrouped ? (
        <ImporterGroupStocks importerId={importerId} />
      ) : (
        <ImporterStocks importerId={importerId} />
      )}
    </div>
  )
}

export default ImporterStockContainer
